import { z } from 'zod';

export const transferLinkSchema = z.object({
    email: z.string().min(1, 'Email is required').email('Please enter a valid email address'),
    username: z.string().min(1, 'Username is required'),
});

export type TransferLinkFormData = z.infer<typeof transferLinkSchema>;
